export enum CoreExternalRoutes {
  SipcRoute = 'https://www.sipc.org',
  DrivewealthFinraBrokerCheck = 'https://brokercheck.finra.org/firm/summary/165429',
  FinraBrokerCheck = 'https://brokercheck.finra.org/firm/summary/287507',
  JikoUsTreasuriesRiskDisclosures = 'https://jiko.io/docs/treasuries_risk_disclosure.pdf',
  JikoSecuritiesCrs = 'https://jiko.io/docs/JikoSecuritiesFormCRS.pdf',

  adv2ABAndCRS_EGW = 'https://adviserinfo.sec.gov/firm/summary/326535',
  finraBrokerCheck_APEX = 'https://brokercheck.finra.org/firm/summary/13071',
  finraBrokerCheck_baseUrl = 'https://brokercheck.finra.org/',
}
